// import Vue from 'vue'
// import Router from 'vue-router'
const Router = require('vue-router') 
import Home from '@/pages/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '足踝外科电子杂志官网',
        content: {
          keywords: '足踝外科电子杂志官网',
          description: '足踝外科电子杂志创刊于2014年6月，是由国家卫生健康委员会主管、人民卫生出版社有限公司主办的足踝专业学术电子期刊。主要刊登足踝外科医疗理念进展、临床诊疗技术，以及与临床联系紧密的基础研究、实验研究成果，是目前该领域内容最为丰富的杂志。本刊坚持刊文真实、严谨和科学的原则。充分体现电子杂志的特点，将经典手术、争鸣交流呈现在读者的眼前;以满足广大足踝外科医生对专业水平提高的迫切要求，促进我国足踝外科的进一步发展'
        }
      }
    },
    {
      path: '/detail/:id',
      name: 'Detail',
      component: resolve => require(['../pages/detail'], resolve)
    },
    {
      path: '/ask',
      name: 'Ask',
      component: resolve => require(['../pages/ask'], resolve)
    },
    {
      path: '/consult',
      name: 'Consult',
      component: resolve => require(['../pages/consult'], resolve)
    },
    {
      path: '/certificate',
      name: 'Certificate',
      component: resolve => require(['../pages/certificate'], resolve)
    },
    {
      path: '/contact',
      name: 'Contact',
      component: resolve => require(['../pages/contact'], resolve)
    },
    {
      path: '/journal-detail/:id',
      name: 'JournalDetail',
      component: resolve => require(['../pages/journal/detail'], resolve)
    },
    {
      path: '/journal-list',
      name: 'JournalList',
      component: resolve => require(['../pages/journal/list'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js